import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	width: 100%;
	height: 100%;

	background-color: #f5f5f5;

	font-family: "Mulish";

	padding: 1rem;

	.header {
		display: flex;

		align-items: flex-start;

		width: 100%;
		height: 5%;

		gap: 0.5rem;

		p {
			font-size: 1.2rem;
			font-weight: 600;
			font-family: "Mulish";
		}
	}

	#func {
		color: #252733;
	}

	#name {
		color: #2d7bbc;
	}
`;

export const Content = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	justify-content: center;

	gap: 3rem;

	overflow: auto;

	font-family: "Roboto";

	letter-spacing: 0.4px;

	.show {
		display: flex;
	}

	.hidden {
		display: none;
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;

		position: relative;

		height: 95%;

		border-radius: 0.5rem;

		background-color: white;

		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

		padding-bottom: 1rem;
	}

	.content-header {
		display: flex;
		flex-direction: column;

		height: 6rem;

		justify-content: space-around;

		padding: 1rem 2rem;
	}

	.header-text {
		font-size: 1.75rem;

		color: #2d7bbc;
	}
	.name-header {
		font-size: 1.2rem;
		text-transform: uppercase;
		font-weight: 600;

		margin-bottom: 0.5rem;

		color: #6870a8;
	}

	#content-instruction {
		padding-bottom: 1rem;
		border-bottom: 1px solid #cacaca;

		font-size: 0.9rem;

		color: #bababa;
	}

	#left {
		width: 50%;
	}

	form {
		height: 100%;
	}

	.quests-wrapper {
		display: flex;
		flex-direction: column;

		width: 100%;
		height: 100%;

		overflow: auto;
	}

	.next-page {
		display: flex;

		width: 100%;

		justify-content: center;

		a {
			text-decoration: none;
		}

		button {
			display: flex;

			padding: 1rem;
			border: none;

			border-radius: 0.25rem;

			cursor: pointer;

			text-transform: uppercase;

			align-items: center;

			gap: 0.5rem;

			color: white;
			background-color: #2d7bbc;

			font-weight: 600;
			font-size: 1.2rem;
		}


	}

	.next-page.btn-error{
		button{
			cursor: not-allowed;
			opacity: 0.5;
		}

	}
`;
